import React, { useState } from "react";
import { Avatar, AvatarProps } from "@mui/material";

interface AgentAvatarProps extends Omit<AvatarProps, "src"> {
  avatarPath?: string;
  name: string;
  size?: number;
}

export const AgentAvatar: React.FC<AgentAvatarProps> = ({ avatarPath, name, size = 40, ...props }) => {
  const [imgError, setImgError] = useState(false);

  // Determine which sized avatar to use based on the size prop
  const getOptimizedAvatarPath = (originalPath?: string) => {
    if (!originalPath) return undefined;

    // Extract the base name from the path (e.g., "dana_agent_avatar.png" -> "dana")
    const baseName = originalPath.split("/").pop()?.replace("_agent_avatar.png", "");
    if (!baseName) return originalPath;

    // Choose the appropriate size based on the size prop
    if (size <= 50) {
      // Small avatars for chat lists, message items, etc.
      return `/assets/avatars/small/${baseName}_small.png`;
    } else if (size >= 150) {
      // Medium avatars for coach pages, large displays
      return `/assets/avatars/${baseName}.png`;
    } else {
      // For sizes between 50-100, use medium for better quality
      return `/assets/avatars/medium/${baseName}_medium.png`;
    }
  };

  const optimizedPath = getOptimizedAvatarPath(avatarPath);

  return (
    <Avatar src={imgError ? undefined : optimizedPath} sx={{ width: size, height: size, ...props.sx }} onError={() => setImgError(true)} {...props}>
      {name.split(" ")[0][0]}
    </Avatar>
  );
};
